module.exports = "/_next/static/images/ourPartnersAlticeLogo-a0044e5d612aff9f67f0087591d8788d.webp";